import { createFileRoute } from "@tanstack/react-router"
import { SigninEmailPage } from "@/pages/onboarding"

export const Route = createFileRoute("/onboarding/signin-email")({
	component: SigninEmailPage,
})
